import React, { useEffect, useRef, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import zkcandyLogo from './images/logo-zkcandy.webp';
import ClaimButton from './components/ClaimButton';
import WalletButton from './components/WalletButton';
import { useWalletConnect } from './WalletConnectProvider';
import axios from 'axios';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

function App() {
  const { address, switchNetwork, connect } = useWalletConnect();
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  const ensureCorrectNetwork = async () => {
    try {
      await switchNetwork();
    } catch (error) {
      toast.error('Failed to switch network. Please switch to the correct network manually.');
      throw error; // Re-throw the error to stop further execution
    }
  };

  async function sendRequest(data, url, method = "post", params = null) {
    let config = {
      method: method,
      url: url,
      headers: {
        'Content-Type': 'application/json',
      },
    };
    if (data) config.data = JSON.stringify(data);
    if (params) config.params = params;
    // console.debug("config: ", config);
    return await axios.request(config).catch(function (error) {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
  }

  const claimToken = async (toAddress, token) => {
    try {
      await ensureCorrectNetwork();
      // console.debug("recaptcha token:", token);
      // console.debug("address:", toAddress);

      const response = await sendRequest(
        { address: toAddress, recaptchaToken: token },
        `${process.env.REACT_APP_API_URL}`
      );

      // Log the entire response to understand its structure
      // console.debug("Full response:", JSON.stringify(response));

      // Adjust the success check based on the actual response structure
      const success = response.data?.data?.success;

      if (success) {
        toast.success('Transaction sent successfully!');
      } else {
        const errorMessage = response.data?.data?.message || "zkCandy API";
        toast.error(`Error in transaction: ${errorMessage}`);
      }
    } catch (err) {
      toast.error(`Error claiming token: ${err.message}`);
    }
  };


  const handleConnectWallet = async () => {
    try {
      await connect();
      toast.success('Wallet connected successfully!');
    } catch (error) {
      toast.error('Failed to connect wallet');
    }
  };

  const onloadCallback = () => {
    if (recaptchaRef.current && !recaptchaRef.current.hasChildNodes()) {
      window.grecaptcha.render(recaptchaRef.current, {
        sitekey: RECAPTCHA_SITE_KEY,
        theme: 'dark',
        callback: (token) => {
          // console.debug('reCAPTCHA token received:', token);
          setRecaptchaToken(token);
        },
      });
    }
  };

  useEffect(() => {
    if (window.grecaptcha) {
      onloadCallback();
    } else {
      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit';
      script.async = true;
      script.defer = true;
      window.onloadCallback = onloadCallback;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [address]);

  return (
    <div className="faucet">
      <ToastContainer />
      <nav className="navbar">
        <div className="container">
          <div className="navbar-brand">
            <div className="navbar-logo">
              <img src={zkcandyLogo} alt="ZKcandy Logo" />
            </div>
          </div>
          <div id="wallet">
            <div>
            </div>
          </div>
        </div>
      </nav>
      <section className="hero is-fullheight">
        <div className="faucet-hero-body">
          <div className="container has-text-centered main-content">
            <h1 className="title">Faucet</h1>
            <div className="address-box">
              <div className="columns is-centered">
                <div className="column is-half">
                  {address && <div className="sub-title">Wallet Address</div>}
                  <WalletButton handleConnectWallet={handleConnectWallet} />
                </div>
              </div>
              {address && address.length > 0 ? (
                <div className="columns is-centered">
                  <div className="column is-half">
                    <div className="captcha" ref={recaptchaRef}></div> {/* reCAPTCHA Container */}
                    <ClaimButton walletAddress={address} claimToken={() => claimToken(address, recaptchaToken)} />
                    <p className="side-note mt-2">
                      &lsaquo; MAX &rsaquo; 0.2 ETH / WEEK 
                    </p>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;
